<template>
  <div class="box sp" style="padding: 10px !important;">
    <div class="top">
      <div class="titles">{{ $t('label.setting.col.1') }}</div>
    </div>
    <TablesTab :labelType="1" :table_columns="table_columns"
               @handleDelete="deleteBlackEmail"></TablesTab>
    <!--      <div class="pages">-->
    <!--        <el-button type="primary" size="small" :icon="Plus" @click="handleAddNewTag(1)">{{-->
    <!--            $t('label.btn.add')-->
    <!--          }}-->
    <!--        </el-button>-->
    <!--        <el-pagination-->
    <!--            size="small"-->
    <!--            v-model:current-page="customerOriginSetting.current"-->
    <!--            v-model:page-size="customerOriginSetting.size"-->
    <!--            background-->
    <!--            layout="total, prev, pager, next"-->
    <!--            v-if="customerOriginSetting.total"-->
    <!--            :total="customerOriginSetting.total"-->
    <!--            @current-change="handleCurrentChange"-->
    <!--        />-->
    <!--      </div>-->
  </div>
  <div style="height: 8px;background: #f0f0f0;width: 100%;"></div>
  <div class="box sp" style="padding: 10px !important;">
    <div class="top">
      <div class="titles">{{ $t('label.setting.col.t2.1') }}</div>
    </div>
    <TablesTab :labelType="2" :table_columns="table_columns"
               @handleDelete="deleteBlackCustomer"></TablesTab>
    <!--      <div class="pages">-->
    <!--        <el-button type="primary" size="small" :icon="Plus" @click="handleAddNewTag(2)">{{-->
    <!--            $t('label.btn.add')-->
    <!--          }}-->
    <!--        </el-button>-->
    <!--        <el-pagination-->
    <!--            size="small"-->
    <!--            v-model:current-page="customerIntentionProduct.current"-->
    <!--            v-model:page-size="customerIntentionProduct.size"-->
    <!--            background-->
    <!--            layout="total, prev, pager, next"-->
    <!--            v-if="customerIntentionProduct.total"-->
    <!--            :total="customerIntentionProduct.total"-->
    <!--            @current-change="handleCurrentChangeProduct"-->
    <!--        />-->
    <!--      </div>-->
  </div>
</template>


<script setup>
import Card from "@/views/Customer/Cards.vue";
import {i18n} from "@/lang";
import {ref} from "vue";
import TablesTab from "@/views/TablesTab.vue";
import {Plus} from "@element-plus/icons-vue";
import AddNewTagDialog from "@/views/components/addNewTagDialog.vue";
import ReturnEmails from "@/components/DiaPops/Returns/ReturnEmails.vue";

const table_columns = ref([
  {key: i18n.global.t('label.col.table.1'), value: "labelName"},
  {key: i18n.global.t('label.col.table.2'), value: "createTime"},
  {key: i18n.global.t('label.col.table.3'), value: "remark"},
])

const tableDataOrigin = ref([{
  tabName: "标签1",
  createTime: "2025-09-01",
  remark: "adsfasdfasdfa1",
}, {
  tabName: "标签2",
  createTime: "2025-09-01",
  remark: "adsfasdfasdfa2",
}])

const tableDataOriginCopy = ref([{
  tabName: "标签1",
  createTime: "2025-09-01",
  remark: "adsfasdfasdfa1",
}, {
  tabName: "标签2",
  createTime: "2025-09-01",
  remark: "adsfasdfasdfa2",
}])


const deleteBlackEmail = () => {

}

const customerOriginSetting = ref({
  current: 1,
  size: 10,
  total: 2,
})
const handleCurrentChange = () => {

}


const deleteBlackCustomer = () => {

}
const customerIntentionProduct = ref({
  current: 1,
  size: 10,
  total: 2,
})

const handleCurrentChangeProduct = () => {

}


</script>


<style lang="less" scoped>
@import "../../less/page.less";

.sp {
  background: transparent !important;
  margin-bottom: 8px !important;
}

.pages {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#Card {
  padding: 0px !important;
}

:deep(.el-card__body) {
  padding: 0px !important;
}

.titles {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  margin-top: 10px;
}
</style>